import React, {useMemo} from 'react';
import Select, {ValueType} from 'react-select';
import classNames from 'classnames';
import get from 'lodash/get';
import {FormikProps} from 'formik';
import {commonStyles} from "../../selectStyles/customSelectStyles";
import styles from './styles.module.scss';

type Option = { label: string; value: number };

type Props = {
  name: string;
  formik: FormikProps<any>;
  options: Option[];
  label?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  isSearchable?: boolean;
  customContainerStyles?: string;
  customLabelStyles?: string;
  onChange?: (value: number | null, formik: FormikProps<any>) => void;
};

export const FormikSelect = ({
                               name,
                               formik,
                               options = [],
                               label,
                               onChange,
                               placeholder = 'בחר',
                               disabled = false,
                               isSearchable = false,
                               customContainerStyles,
                               customLabelStyles,
                             }: Props) => {
  const valueId: number | null = get(formik.values, name) ?? null;

  const selectedOption = useMemo(
    () => {
      return options && options.length > 0 ? options.find((o) => o.value === valueId) : null
    },
    [options, valueId, formik.values]
  );

  const handleChange = (option: ValueType<Option, false>) => {
    const newValue = option?.value ?? null;

    if (formik && name) {
      formik.setFieldValue(name, newValue);
    }

    if (onChange) {
      onChange(newValue, formik);
    }
  };

  return (
    <div className={customContainerStyles}>
      {label && <div className={classNames(styles.label, customLabelStyles)}>{label}</div>}
      <Select<Option, false>
        value={valueId === null ? null : selectedOption}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        isDisabled={disabled}
        isSearchable={isSearchable}
        // @ts-ignore
        styles={commonStyles}
        noOptionsMessage={() => 'אין אפשרויות'}
      />
    </div>
  );
};